import React, {useEffect, useState} from "react";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import Footer from "../../../components/footer";

const Matrix = (props) => {
    let history = useHistory();

    const _get_all_findings_matrix = useSelector((state) => state.findings_matrix_module._get_all_findings_matrix);

    const [datas, setDatas] = useState([]);

    useEffect(() => {
        if (_get_all_findings_matrix.data.datos) {
            let v = _get_all_findings_matrix.data.datos.filter(x => x.activo === true);
            setDatas(v);
        }
    }, [_get_all_findings_matrix]);

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Matríz de hallazgo"
                            items={[{label: "Consulta de resultados", link: "/matriz"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                            <div className="row mt-1">
                                    <div className="mb-1 col-12">
                                        <div className="pl-1 pr-1 border_card">
                                            <p style={{marginTop: 10, fontSize: 18, color: '#727E8C'}}>Consulta de resultados</p>
                                        </div>
                                    </div>
                                    {(datas.length > 0) && (
                                        datas.map((item) => (
                                            <div className="col-md-6 col-12 mb-1">
                                                <div className="d-flex p-1 border_card" style={{cursor: 'pointer'}} onClick={() => {
                                                    history.push(`/matriz-item/${item.id}/${item.nombre}`);
                                                }}>
                                                    <div className="d-flex">
                                                        <div className="ml-1">
                                                            <strong className="texto_16">{item.nombre}</strong><br/>
                                                            <strong className="texto_14">Hoja de trabajo: {item.hoja_trabajo}</strong><br/>
                                                            <span className="texto_14">{item.tipo}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
};

export default Matrix;
